import axios from "axios";
import helpers from "@/helpers.js";
import store from '../../store'
// import firebase from "firebase";

class Companies {

    constructor() {

    }

    get() {

        let params = "" ;

        // params = params + "&company_id="+store.state.companies.currentCompany.id ;
        
        store.commit("app/SET_LOADER", true) ;

        return helpers.get_token().then(function(idToken) {
            
            const config = {
                headers: { Authorization: "Bearer " + idToken }
            };
            
            return axios.get( 
                helpers.get_api_endpoint("/companies", params),
                config
            ).then(function(response) {

                // console.log('companiesss');
                // console.log(response.data);

                store.commit("companies/setCompanies", response.data) ;
                store.commit("app/SET_LOADER", false) ;

                return response.data ; 

            })
            .catch(error => {
                store.commit("app/SET_ERROR", error) ;
                return error ; 
            });

        }).catch(function(error) {

            store.commit("app/SET_ERROR", error) ;
            return error ; 
  
        });
        
    }

}

export default Companies ;
